interface Props {
  size?: number
  className?: string
}

export default function Logo({ size = 24, className }: Props) {
  return <img src="/icons/logo.svg" alt="" width={size} height={size}
    className={className}
    style={{ width: size, height: size, objectFit: 'contain' }} />
}